import axios from 'axios';

let isAxiosConfigured = false;

export const axiosConfigSetting = () => {
  if (isAxiosConfigured) return;
  isAxiosConfigured = true;

  axios.defaults.baseURL = process.env.REACT_APP_API_URL;

  // 요청 인터셉터
  axios.interceptors.request.use(
    async (config) => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
      } catch (e) {
        return config;
      }
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // 응답 인터셉터 - 401 처리
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        // 로그인 API 요청의 401은 리다이렉트하지 않음 (잘못된 아이디/비밀번호)
        const requestUrl = error.config?.url || '';
        if (requestUrl.includes('/auth/') && requestUrl.includes('/login')) {
          return Promise.reject(error);
        }
        localStorage.removeItem('token');
        const hostname = window.location.hostname;
        const pathname = window.location.pathname;
        const isPaper = hostname === 'pinkpaper.kr' || hostname === 'www.pinkpaper.kr' || pathname.startsWith('/paper/layouts') || pathname.startsWith('/paper/layout');
        const isPublic = hostname === 'impink.co.kr' || hostname === 'www.impink.co.kr' || hostname === 'urpink.co.kr' || hostname === 'www.urpink.co.kr' || hostname === 'localhost' || hostname === '100.68.115.13' || hostname === '100.116.73.97';
        const isDist = hostname === 'kdist.net' || hostname.endsWith('.kdist.net');
        let loginPath;
        if (isPaper) {
          loginPath = hostname === 'pinkpaper.kr' || hostname === 'www.pinkpaper.kr' ? '/login' : '/paper/login';
        } else if (isPublic || isDist) {
          loginPath = '/login';
        } else {
          loginPath = '/public/login';
        }
        const msg = error.response?.data?.message;
        if (msg) {
          // 메시지가 있으면 alert 후 redirect (setTimeout으로 모달이 닫힌 뒤 이동)
          window.alert(msg);
          setTimeout(() => { window.location.href = loginPath; }, 300);
        } else {
          window.location.href = loginPath;
        }
      }
      return Promise.reject(error);
    }
  );
};
